import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      video: {
         insertVideoContent: (videoUrl: string, videoCaption: string) => ReturnType;
      };
   }
}

export const Video = Extension.create({
   name: 'video',

   addCommands() {
      return {
         insertVideoContent:
            (url: string, caption: string) =>
            ({ commands, dispatch }) => {
               const formattedCaption = caption ? ']' + caption + '[/video]' : ']';
               const formattedUrl = /https?:\/\//.test(url) ? url : 'http://' + url;

               if (dispatch) {
                  commands.insertContent('[video|' + formattedUrl + formattedCaption);
               }

               return true;
            },
      };
   },
});
